export default __webpack_public_path__ + "static/media/male_04.142854cb.png";